import React from 'react';
import { getI18NMessage } from 'I18N/I18NHelper';
import { changeHomePage } from 'js/app/actions/AppActions';
import { emptyICConfig } from 'js/modules/issue/actions/IssueConfigActions';
import { GLOBAL_CONSTANTS } from 'js/common/constants/GlobalConstants';
import EmbedCodeContainer from './EmbedCodeContainer';
import AppUtil from 'js/utils/AppUtil';

class IssueCollectorCongratsView extends React.Component {
	constructor(props) {
		super(props);

        this.state = {};
	}

	render() {
		return (
			<div className='ic_create_screen full_width full_height'>
                <img src={ AppUtil.processURLForAppContextPath('images/celebrate.png') } 
                    className='congrates_img float_left' alt="congrats"></img>
                <span className='float_right view_list_btn cur_pointer' onClick={ this.loadColletorListing.bind(this) }>{ getI18NMessage('view_collector_list') }</span>
                <span className='float_left congrats_text bold'>{ getI18NMessage('congrats') }</span>
                <span className='float_left congrats_msg'>{ getI18NMessage('success_create_msg') }</span>
                <div className='emc_cnt float_left'>
                    <EmbedCodeContainer fromCongratsView={ true } />
                </div>
            </div>
		);
    }
    
    /* istanbul ignore next */
    loadColletorListing() {
        this.props.store.dispatch( changeHomePage(GLOBAL_CONSTANTS.ISSUE_LISTING) );
        this.props.store.dispatch( emptyICConfig() );
    }
}

export default IssueCollectorCongratsView;